import { render, staticRenderFns } from "./QuizQuestionLikertV2.vue?vue&type=template&id=1b0cc356&scoped=true"
import script from "./QuizQuestionLikertV2.vue?vue&type=script&lang=js"
export * from "./QuizQuestionLikertV2.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionLikertV2.vue?vue&type=style&index=0&id=1b0cc356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0cc356",
  null
  
)

export default component.exports